import { Text } from '@kognitos/lattice';

export interface IRainReasoningRowProps {
  /** The reasoning stretch's text. */
  content: string;
}

/**
 * One reasoning stretch inside an opened work run.
 *
 * Exists so the row can leave the `THINKING` type behind. That type is
 * lattice's grouping key: an open run puts its rows back in the transcript, and
 * a `THINKING` row there is regrouped into a `ChatThinkingMessage` that mounts
 * collapsed — so opening a run would reveal another closed header rather than
 * the prose. Retyping alone is not enough either, since a plain message renders
 * as an ordinary bubble and reasoning would read as something the agent said to
 * the operator.
 *
 * Matches the treatment `ChatThinkingMessage` gives the same text, so folding a
 * run does not change how its reasoning looks.
 */
export function RainReasoningRow({ content }: IRainReasoningRowProps) {
  return (
    <Text
      level="xSmall"
      color="muted"
      className="whitespace-pre-wrap wrap-break-word break-anywhere opacity-80"
      data-testid="rain-reasoning-row"
    >
      {content}
    </Text>
  );
}
